<template>
    <div
            class="diary-project-post"
            :class="{'diary-project-post_mobile': $vuetify.breakpoint.xsOnly}"
    >
        <v-progress-linear
                v-if="loading"
                indeterminate
        ></v-progress-linear>
        <div
                v-if="!loading && value.length === 0"
                class="diary-project-post__no-records"
        >{{ $t('msg.noRecords') }}</div>
        <v-card
                v-if="!loading"
                v-for="(post, key) in value"
                :key="post.id"
                class="diary-project-post__card"
        >
            <div
                class="diary-project-post__day"
                :style="{
                    'background-color': $vuetify.theme.themes.light.primary
                }"
                :title="$t('msg.numberDaysFromStartTarget')"
            >{{ post.day }} {{ $t('msg.day') }}</div>
            <div class="diary-project-post__cells">
                <div
                    v-if="withAuthor"
                    class="diary-project-post__cell-info"
                >
                    <author
                        :value="post"
                        @change="v => value[key] = v"
                        @change-follow="v => changeFollow(v, post.user_id)"
                        class="diary-project-post__author"
                    ></author>
                </div>
                <div class="diary-project-post__cell-content">
                    <div
                        v-if="post.id !== null"
                        class="diary-project-post__info"
                    >
                        <login
                                v-if="$vuetify.breakpoint.xsOnly && withAuthor"
                                v-model="post.login"
                        ></login>
                        <div v-else></div>
                        <div class="diary-project-post__time-wrap">
                            <div class="diary-project-post__time">{{ dateString(post.date) }} {{ post.date | dateMin }}</div>
                            <btn-edit
                                    v-if="!withAuthor || (withAuthor && post.is_my_diary)"
                                    class="ml-1"
                                    @click="indexOpenForm = key"
                            ></btn-edit>
                        </div>
                    </div>
                    <v-card-text
                        class="diary-project-post__msg"
                    >
                        <template
                            v-if="indexOpenForm !== key"
                        >{{ post.msg }}</template>
                        <images
                                v-if="indexOpenForm !== key"
                                v-model="post.images"
                                class="images"
                        ></images>
                        <form-post
                            v-if="indexOpenForm === key"
                            :value="post"
                            :index="key"
                            :target-id="post.target_id"
                            :target-dairy-id="post.id"
                            @input="v => value[key] = v"
                            @close-form="closeForm(key)"
                            @added="indexOpenForm = null"
                            class="diary-project-post__form"
                            :class="{
                                'mt-6': post.id === null
                            }"
                        ></form-post>
                    </v-card-text>
                    <comments
                        v-if="post.id !== null"
                        :count="post.count_comments"
                        :target-id="post.target_id"
                        :target-dairy-id="post.id"
                        class="diary-project-post__comments"
                    ></comments>
                </div>
            </div>
        </v-card>
    </div>
</template>

<script>
import Comments from "./Comments";
import FormPost from "./FormPost";
import Author from "./Author";
import BtnEdit from "../../ui/BtnEdit";
import Images from "../../ui/Images";
import Login from "../../ui/Login";

export default {
    components: {Comments, FormPost, Author, BtnEdit, Images, Login},
    props: {
        value: Array,
        withAuthor: {type: Boolean, default: false},
        loading: {type: Boolean, default: false}
    },
    data() {
        return {
            indexOpenForm: null
        }
    },
    methods: {
        closeForm(index) {
            if (this.value[index].id === null) {
                this.value.splice(0, 1);
            }
            this.indexOpenForm = null;
        },
        changeFollow(v, userId) {
            this.value.forEach((item, key) => {
                if (item.user_id === userId) {
                    this.value[key].is_follow_user = v;
                }
            });
        }
    }
}
</script>

<style lang="scss">
@import './src/assets/scss/vars';

.diary-project-post {
    position: relative;

    &.diary-project-post_mobile {
        .diary-project-post__cells {
            display: block;
        }
        .diary-project-post__info {
            padding-right: 10px;
            padding-left: 10px;
            justify-content: space-between;
        }
        .diary-project-post__msg {
            padding-left: 10px;
            padding-right: 10px;
            padding-bottom: 10px;
        }
        .diary-project-post__cell-info {
            width: inherit !important;
            border-right: 0;
        }
        .diary-project-post__author {
            padding-left: 10px;
            padding-right: 10px;
            padding-bottom: 0;
        }
    }
}
.diary-project-post__card {
    margin-top: 30px;

    &:first-child {
        margin-top: 0;
    }
}
.diary-project-post__day {
    height: 30px;
    position: absolute;
    top: -15px;
    left: 15px;
    border-radius: 4px;
    font-size: 15px;
    display: flex;
    align-items: center;
    color: #fff;
    padding: 0 15px;
}
.diary-project-post__msg {
    padding-top: 10px;
    white-space: pre-wrap;
}
.diary-project-post__info {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-size: 12px;
    padding: 16px 16px 0 0;
}
.diary-project-post__time {
    font-style: italic;
}
.diary-project-post__comments {
    border-top: 1px solid #d8d8d8;
}
.diary-project-post__edit {
    font-size: 16px !important;
    cursor: pointer;
    margin-left: 5px;

    &:hover {
        color: $colorPrimary;
    }
}
.diary-project-post__cells {
    display: flex;
}
.diary-project-post__cell-info {
    width: 200px;
    border-right: 1px solid #d8d8d8;
}
.diary-project-post__cell-content {
    flex: 1;
}
.diary-project-post__author {
    padding: 22px 15px 15px 15px;
}
.diary-project-post__time-wrap {
    display: flex;
}
.diary-project-post__no-records {
    display: flex;
    justify-content: center;
}
</style>